import styles from '../styles/bim.module.scss';
import React, { useEffect, useState, useContext, useRef } from 'react';
import 'react-range-slider-input/dist/style.css';
import { Slab } from "react-loading-indicators"
import { Context } from '../Context';
import { useTranslation } from 'react-i18next';

const SvgCell = ({ key, row, layoutList }) => {

  const [svgContent, setSvgContent] = useState(null);
  const {dataUrl, isMobile, setActiveApartmentHandle, mobileActiveView } = useContext(Context);
  const { t } = useTranslation();

  const svgRef = useRef(null)

  // async function fetchCss(edifice){
  //   try {
  //     const response = await fetch(
  //       /* webpackMode: "eager" */
  //       `${dataUrl}edifices/${edifice}/apartments/aprt.css`
  //     );
  //     if (response.ok) {
  //       const text = await response.text();        
  //       return text;
  //     }
  //   } catch (error) {
  //   }
  // }

  const fetchSvgContent = async () => {
    if (!layoutList) {
      try {
        
        const ref_tier = String(row.ref_tier).padStart(2, '0');
        const uuid = row.uuid;
        // const svgPath = `${dataUrl}edifices/${row.edifice_name}/apartments/${uuid}_${ref_tier}.svg`;
        const svgPath = `${dataUrl}apartments/${uuid}/${uuid}_${row.building_id}-00-${ref_tier}.svg`;

        const response = await fetch(svgPath);
        if (!response.ok) throw new Error(`Failed to fetch SVG: ${response.statusText}`);
        
        const blob = await response.blob(); 
        const svgText = await blob.text(); 

        // const defsPath = `${dataUrl}edifices/${row.edifice_name}/apartments/defs.svg`;
        const defsPath = `${dataUrl}apartments/defs.svg`;
        
        try {
          const modifiedText = svgText.replace(
            /defs\.svg/g, defsPath
          ).replace(/<svg /g, '<svg width="100%" height="100%" ');

          setSvgContent(modifiedText);  // Ustawiamy zmodyfikowany SVG w stanie
        } catch (error) {
          console.error("Error fetching CSS:", error);
        }
      } catch (error) {
        console.error("Error fetching apartment miniature SVG:", error);
      }
    }
  };

  useEffect(() => {

    // if (svgRef.current) {
    //   const svgPaths = svgRef.current.querySelectorAll('path.rm');
    //   const compartments = row.compartments
      
    //   compartments.forEach((compartment,index) => {
        
    //     const compartmentClass = compartment.name.replace(/\./g, "-");
    //     svgPaths[index].classList.add(compartmentClass);

    //   });
    // }
   
  }, [svgContent])
  

  useEffect(() => {
    fetchSvgContent();
  }, [layoutList, row.id, key]); 
  

  return (
    <div className={styles.svg_miniatures_container}>
      {!layoutList && (
        (svgContent ? (<div
          ref={svgRef}
          className={styles.svg_miniatures}
          dangerouslySetInnerHTML={{ __html: svgContent }}
        />) : (
          <div className={styles.svg_miniatures}>
            <Slab size="small" color={`#d3d3d3`} text={t('loading')} />
          </div>
        ))
      )}
    </div>
  );
};

export default SvgCell;
